__turbopack_context__.v({
  "actionButtonContainer": "iC66ya_actionButtonContainer",
  "cartBtnSkeleton": "iC66ya_cartBtnSkeleton",
  "signInButton": "iC66ya_signInButton",
  "vibrate": "iC66ya_vibrate",
  "whiteLabeled": "iC66ya_whiteLabeled",
});
